<template>
  <div class="modal-window bds089">
      <header class="modal-header">
          <div class="tit" @dblclick="openSnapshot()">{{$i18nUtil.trans("message.BoardSnapshot.001","보드 상세 정보")}}</div>
      </header>
      
      <div class="modal-content">
          <div class="info-txt big">{{paperInfo.paperTitle}}</div>
          <!-- <div class="info-txt small"><span class="date">{{$moment(paperInfo.regDate).format('YYYY-MM-DD HH:mm')}}</span>에 피드백을 요청한 보드의 스냅샷입니다.</div> -->
          <div class="info-txt small" v-html="$i18nUtil.trans('message.BoardSnapshot.002','{date}에 피드백을 요청한 보드의 스냅샷입니다.',{date:$moment(paperInfo.regDate).format('YYYY-MM-DD HH:mm')})"></div>
          <div class="img-box">
              <div class="scroll">
                <div class="board_wrap">
                  <BoardContent
                    :userInfo="userInfo"
                    :paperInfo="paperInfo"
                    :boardSection="boardSection"
                    :boardMemberInfo="boardMemberInfo"
                    :todoSelectedblockId="todoId"
                  />
                </div>
              </div>
          </div>
      </div>
  </div>
  <!-- <div class="board_wrap" v-if="isPaper() === 1">

    <div>{{$moment(paperInfo.regDate).format('YYYY-MM-DD HH:mm')}}</div>
    <BoardContent
      :userInfo="userInfo"
      :paperInfo="paperInfo"
      :boardSection="boardSection"
      :boardMemberInfo="boardMemberInfo"
      :todoSelectedblockId="todoId"
    />
  </div> -->
</template>

<script>
import axios from "axios";
/* 업무보드 css */
import Paging from "../../../../../assets/css/board.css";
/* 업무보드 주화면 */
import BoardContent from "../base/BoardContent";
/* 지연처리를 위한 플러그인 */
import lodash from "lodash";

export default {
  components: {
    BoardContent
  },
  data() {
    return {
      userInfo: {
        userId: "",
        userName: ""
      },
      /* 업무보드사용자목록 */
      boardMemberInfo: {
        userList: [],
        paperUser: [],
        projectUser: []
      },
      /* 업무보드 데이터 */
      paperInfo: {
        /* 업무보드 ID */
        paperId: this.$route.params.paperId,
        /* 업무보드 제목 */
        paperTitle: "",
        groupId: null,
        copyGroupId: null,
        /* 읽기전용여부 */
        readonly: 1,
        /* 내/외부망 구분 (IN, OUT) */
        inOutState: "IN",
        /* 보드권한 0:조회불가, 1:조회가능, 2:편집가능 */
        permission: 0,
        categoryInfo: { }
      },
      todoId: this.$route.params.todoId,
      boardSection: [ "SNAPSHOT" ],
      // state: { }
    };
  },
  watch: {
    paperInfo: {
      handler() {
        let section = "SNAPSHOT";
        this.boardSection.splice(0, 1, section);
      },
      deep: true,
    },
    boardSection: {
      handler() {
      },
    },
  },
  mounted() {
    this.isPaper();
  },
  methods: {
    isPaper() {
      if (this.paperInfo.paperId.match(/^PAPE[0-9]{17}[a-zA-Z]{4}/)) {
        return 1;
      }
      else if (this.paperInfo.paperId.match(/^BLOC[0-9]{17}[a-zA-Z]{4}/)) {
        return 2;
      }
      return 0;
    },
    openSnapshot() {
      window.open(window.location.href, "_blank", "width=1264, height=800");
    }
  }
};
</script>
<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/base/BoardSnapshot.vue